define('components/stratemanager/StrateManager', [
    'components/stratemanager/models/StrateManagerModel',
    'components/stratemanager/views/StrateManagerView'
], function(StrateManagerModel, StrateManagerView) {

    var _model = new StrateManagerModel();
    var _view = new StrateManagerView({ "model": _model });

    return {
        create: function(options) {
            _model.set(options);
            _view.render();
        },

        remove: function() {
            //TODO
        },

        addStratesList: function(stratesList) {
            _view.addStratesList(stratesList);
        },

        addStrate: function(strateView, navName, showNav, navClassName) {
            _view.addStrate(strateView, navName, showNav, navClassName);
        },

        removeStrate: function(strateId) {
            _view.removeStrate(strateId);
        },

        addNavItem: function(navObj) {
            _view.addNavItem(navObj);
        },

        getStratePosition: function(strateId) {
            return _view.getStratePosition(strateId);
        },

        getStrateView: function(strateId) {
            return _view.getStrate(strateId).view;
        },

        updateStratePosition: function() {
            _view.updateStratePosition();
        },

        enterCurrentStrate: function() {
            _view.enterCurrentStrate();
        },

        leaveCurrentStrate: function() {
            _view.leaveCurrentStrate();
        },

        onScroll: function(e, onStrateChangeCallback) {
            _view.onScroll(e, onStrateChangeCallback);
        },

        onResize: function(e) {
            _view.onResize(e);
        }
    };
});
